import ApplicationState from '../ApplicationState';
import loadIndicator from '../LoadIndicator';
import infoModal from '../modal/InfoModal';

const xhr = ApplicationState.axios;

let getModalId = (formId: string) => formId + '-modal';
/**
 * Загрузчик форм
 * 
 * @param {string} triggerSelector 
 * @param {function} onFormLoaded - функция, вызываемая после успешной загрузки формы
 * @param {function} onClick      - функция, вызываемая при каждом клике по кнопке
 */
export default function modalLoader(
    triggerSelector: string,
    onFormLoaded: (modalId: string) => void,
    onClick: (modalId: string) => void,
    params: object = null,
    url: string = null
) {
    let triggers = document.querySelectorAll(triggerSelector) as NodeListOf<HTMLElement>;

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            loadModal(trigger, onFormLoaded, onClick, params, url);
        });
    });
}

export function loadModal(
    trigger: HTMLElement,
    onFormLoaded: (modalId: string) => void,
    onClick: (modalId: string) => void,
    params: object = null,
    url: string = null
) {
    const formId = trigger.dataset.modal;
    const modalId = getModalId(formId);

    if (document.getElementById(modalId) === null) {
        loadIndicator(trigger);

        loadForm(formId, params, url).then(rsp => {
                try {
                    document.body.insertAdjacentHTML('beforeend', rsp.data);
                    onClick(modalId);
                    onFormLoaded(formId);
                } catch (e) {
                    console.error(e);
                    throw e; // пробрасываем ошибку дальше
                }
            })
            .catch(() => infoModal('Ошибка', 'Не удалось загрузить форму'))
            .then(() => loadIndicator(trigger, true));
    } else {
        onClick(modalId);
    }
}

export function loadForm(formId: string, params: object = null, url: string = null) {
    let modalId = getModalId(formId);
    let data = new FormData;

    data.append('formId', formId);
    data.append('modalId', modalId);

    if (params !== null) {
        for (let paramName in params) {
            if (params.hasOwnProperty(paramName)) {
                data.append(paramName, params[paramName]);
            }
        }
    }

    return xhr.post(url === null ? '/modal/render_form/' : url, data);
}
